<template>
  <div>
    <b-row class="row-deck">
      <!-- Latest Customers -->
      <b-col md="12">
        <base-block content-class="p-0">
          <div class="font-size-sm push mb-0">
            <div v-if="dataLoad" class="text-center">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
            </div>
            <b-form v-if="!dataLoad" @submit.stop.prevent="onBaseSearchSubmit">
              <div class="form-row w-100">
                <div class="col-sm-12 col-md-2 mt-3">
                  <flat-pickr size="md" class="form-control form-control-alt border" id="fromDate" placeholder="De la" v-model="$v.searchForm.fromDate.$model" @on-change="makeAttention"></flat-pickr>
                </div>
                <div class="col-sm-12 col-md-2 mt-3">
                  <flat-pickr size="md" class="form-control form-control-alt border" id="toDate" placeholder="Pana la" v-model="$v.searchForm.toDate.$model" @on-change="makeAttention"></flat-pickr>
                </div>
                <b-col class="col-sm-12 col-md-8 mt-3">
                  <b-button v-bind:class="{'animated wobble': searchClickAttention}" size="md" type="submit" variant="primary">
                    <small><i class="fa fa-fw fa-search mr-1"></i> Cautare</small>
                  </b-button>
                  <router-link v-if="search" class="btn btn-md btn-warning ml-2" to="/client-data-sheet" active-class="" v-on:click.native="onClearFilters">
                    <small><i class="fa fa-fw fa-times-circle mr-1"></i> Reseteaza</small>
                  </router-link>
                  <b-button size="md" type="submit" class="ml-2" variant="success" @click="print">
                    <small><i class="fa fa-fw fa-print mr-1"></i> Tipareste</small>
                  </b-button>
                </b-col>
              </div>
            </b-form>
          </div>
        </base-block>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
// Flatpickr + Custom overrides
@import '~flatpickr/dist/flatpickr.css';
@import './src/assets/scss/vendor/flatpickr';
</style>

<script>
import {validationMixin} from "vuelidate";
import flatPickr from "vue-flatpickr-component";
import {fleshErrorMessage} from "../../../../error/server-error";
import {PRINT_CLIENT_DATA_SHEET} from "@/constants/client-data-sheet-graphql";

export default {
  name: "Search",
  components: {flatPickr},
  mixins: [validationMixin],
  props: {
    search: null,
    totalPage: null
  },
  data () {
    return {
      dataLoad: false,
      searchClickAttention: null,
      categories: [],
      searchTerm: this.search,
      searchForm: {
        fromDate: null,
        toDate: null,
      },
    }
  },
  validations: {
    searchForm: {
      fromDate: {},
      toDate: {},
    }
  },
  methods: {
    onClearFilters() {
      this.searchForm = {
        fromDate: null,
        toDate: null,
      };
    },
    onBaseSearchSubmit() {
      this.$v.searchForm.$touch();
      let path = "/client-data-sheet";
      if (this.searchForm.keyword || this.searchForm.fromDate || this.searchForm.category || this.searchForm.toDate) {
        path = "/client-data-sheet?search="+btoa(JSON.stringify(this.searchForm));
      }
      this.$router
          .push(path)
          .catch(error => {
            error = {};
            fleshErrorMessage(error, this);
          });
    },
    makeAttention() {
      this.searchClickAttention = 'animated wobble';
      setTimeout(() => this.searchClickAttention = null, 1200);
    },
    print() {
      this.$apollo.mutate({
        mutation: PRINT_CLIENT_DATA_SHEET,
        variables: {
          'from': this.getFilterValue('fromDate'),
          'to': this.getFilterValue('toDate'),
        }
      }).then((response) => {
        this.$print(response.data.createPrintClientDataSheet.printClientDataSheet.response);
      }).catch((error) => {
        fleshErrorMessage(error, this);
      })
    },
    getFilterValue(filter)
    {
      if ((this.search && this.search[filter])) {
        return this.search[filter];
      }
    }
  },
  mounted() {
    if (this.search) {
      this.searchForm = this.search;
      this.dataLoad = false;
    } else {
      this.searchForm = {
        category: null,
        toDate: null,
      };
      this.dataLoad = false;
    }
  }
}
</script>